import {useMediaQuery} from '@mui/material';
import {useTheme} from "@mui/material/styles";
import {useEffect, useState} from "react";

const useWindowSize = () => {
    const theme = useTheme();
    const [isLoadingBreakpoints, setIsLoadingBreakpoints] = useState(true);

    /*
    * A media query string ready to be used with most styling solutions, which matches screen widths
    * starting from the screen size given by the breakpoint key (inclusive) and
    * stopping at the screen size given by the next breakpoint key (exclusive).
    * */
    const isWindowExtraSmall = useMediaQuery(theme.breakpoints.only('xs'));
    const isWindowSmall = useMediaQuery(theme.breakpoints.only('sm'));
    const isWindowMedium = useMediaQuery(theme.breakpoints.only('md'));
    const isWindowLarge = useMediaQuery(theme.breakpoints.only('lg'));
    const isWindowExtraLarge = useMediaQuery(theme.breakpoints.only('xl'));

    /*
    * A media query string ready to be used with most styling solutions, which matches screen widths
    * greater than the screen size given by the breakpoint key (inclusive).
    * */
    const greaterThanWindowExtraSmall = useMediaQuery(theme.breakpoints.up('xs'));
    const greaterThanWindowSmall = useMediaQuery(theme.breakpoints.up('sm'));
    const greaterThanWindowMedium = useMediaQuery(theme.breakpoints.up('md'));
    const greaterThanWindowLarge = useMediaQuery(theme.breakpoints.up('lg'));
    const greaterThanWindowExtraLarge = useMediaQuery(theme.breakpoints.up('xl'));

    /*
    * A media query string ready to be used with most styling solutions, which matches screen widths
    * less than the screen size given by the breakpoint key (exclusive).
    * */
    const lowerThanWindowExtraSmall = useMediaQuery(theme.breakpoints.down('xs'));
    const lowerThanWindowSmall = useMediaQuery(theme.breakpoints.down('sm'));
    const lowerThanWindowMedium = useMediaQuery(theme.breakpoints.down('md'));
    const lowerThanWindowLarge = useMediaQuery(theme.breakpoints.down('lg'));
    const lowerThanWindowExtraLarge = useMediaQuery(theme.breakpoints.down('xl'));

    useEffect(() => {
        if (isWindowExtraLarge || greaterThanWindowExtraLarge || lowerThanWindowExtraLarge) {
            setIsLoadingBreakpoints(false);
        }
    }, [isWindowExtraLarge, greaterThanWindowExtraLarge, lowerThanWindowExtraLarge]);

    return {
        isLoadingBreakpoints,
        isWindowExtraSmall,
        isWindowSmall,
        isWindowMedium,
        isWindowLarge,
        isWindowExtraLarge,
        greaterThanWindowExtraSmall,
        greaterThanWindowSmall,
        greaterThanWindowMedium,
        greaterThanWindowLarge,
        greaterThanWindowExtraLarge,
        lowerThanWindowExtraSmall,
        lowerThanWindowSmall,
        lowerThanWindowMedium,
        lowerThanWindowLarge,
        lowerThanWindowExtraLarge
    };
};

export default useWindowSize;
